<script>
import Gen from '@helper/Gen';
import '@plugins/jquery-validation/jquery-validation.js';

export default {
  name: "VForm",
  props: {
		target: {
			default: ".table-loading"
		},
		method: {
			default: "get"
		},
		type: {
			default: "ajax"
		},
		action: {
			default: location.href,
		},
		data: {
			default: "",
		}
	},
	data(){
		return {
			loading: false,
		}
	},
	mounted:function(){
		$.validator.setDefaults({
			ignore: ".nv",
			errorPlacement: function (error, element) {
				var placement = $("[error='" + element.attr('name') + "']")
				var label = placement.attr('label') || element.attr('name')
				error.text(error.text().replace("{label}", label))
				if (placement.length) {
					placement.html(error)
				} else {
					error.insertAfter(element)
				}
			},
			invalidHandler:function(e, validator){
				if(validator.errorList.length && $("#tabs").length)
					$('#tabs a[href="#' + $(validator.errorList[0].element).closest(".tab-pane").attr('id') + '"]').tab('show')
			}
		})
		$("label[error]").each((k,el)=>{
			if(!$(el).text()) $(el).hide()
		})
		this.form = $(this.$el)
		this.form.validate()
		this.btnBefore = this.form.find(".btn-loading").html()
		this.form.submit((e)=>{
			// Initial
			$('[validate]').each(function(){
				if(!$(this).is("input,textarea,select")) return
				var rules = [], t = 0
				$(this).attr('validate').split("|").forEach((v)=>{
					var ex = v.split(":")
					if(!ex[0]) return
					if(ex[1]){
						rules[ex[0]] = parseInt(ex[1]) ? parseInt(ex[1]) : ex[1]
					}else{
						rules[ex[0]] = true
					}
					t++
				})
				// $(this).removeAttr('validate')
				if(t && this){
					$(this).rules("add", rules)
				}
			})

			e.preventDefault()

			if(!this.validate()) return
			if (this._events.resp) return this.$emit('resp', this)
		});
	},
	methods: {
		validate: function(){
			setTimeout(()=>{
				$("label[error]").each((k,el)=>{
					if($(el).text()) $(el).show()
				})
			}, 100)
			return $(this.$el).valid()
		},
		btnLoading: function(){
			this.form.find(".btn-loading").html('<div class="loading-spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
			setTimeout(()=>{ this.loading = true; }, 2);
		},
		btnUnloading: function(){
			this.form.find(".btn-loading").html(this.btnBefore);
			this.$set(this, 'loading', false)
		},
		tableLoading: function(){
			if(!$(this.target+" .loading-spinner").length) $(this.target).append('<div class="loading-spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>')
			setTimeout(()=>{ this.loading = true; }, 3);
			return this.loading
		},
		tableUnloading: function(){
			$(this.target+" .loading-spinner").remove();
			this.loading = false
		},
	}
}
</script>

<template>
  <form><slot></slot></form>
</template>